import React, { FC } from "react";

const DevelopmentNotice: FC = () => {
  return (
    <div
      style={{
        backgroundColor: "#f8d7da",
        color: "#721c24",
        padding: "10px",
        textAlign: "center",
      }}
    >
      This page is currently in development.
    </div>
  );
};

export default DevelopmentNotice;
